import { render, staticRenderFns } from "./schedules-admin.vue?vue&type=template&id=ca5f36b2&scoped=true&"
import script from "./schedules-admin.vue?vue&type=script&lang=ts&"
export * from "./schedules-admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5f36b2",
  null
  
)

export default component.exports